import { render } from "./AnnouncementDetails.vue?vue&type=template&id=643f0c84&scoped=true"
import script from "./AnnouncementDetails.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetails.vue?vue&type=script&lang=js"

import "./AnnouncementDetails.vue?vue&type=style&index=0&id=643f0c84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643f0c84"]])

export default __exports__